var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { getPartyMembers } from 'services';
import { formattedUserName, formattedUserYear } from 'utils/helpers';
import ProfilePhoto from 'components/ProfilePhoto';
import IconExternalLink from '__assets/images/icon__external-link.svg';
;
var Members = function (_a) {
    var baseClass = _a.baseClass, party = _a.party;
    var _b = useState([]), members = _b[0], setMembers = _b[1];
    useEffect(function () {
        var getMembers = function () { return __awaiter(void 0, void 0, void 0, function () {
            var tempMembers_1, membersSnap, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        tempMembers_1 = [];
                        return [4 /*yield*/, getPartyMembers()];
                    case 1:
                        membersSnap = _a.sent();
                        membersSnap.forEach(function (doc) {
                            tempMembers_1.push(doc.data());
                        });
                        setMembers(tempMembers_1);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        getMembers();
    }, []);
    return (_jsx("div", __assign({ className: baseClass + "__members" }, { children: members.map(function (m, i) { return (_jsxs("div", __assign({ className: "member", "data-is-last": i === members.length - 1 }, { children: [_jsx(ProfilePhoto, { photoURL: m.photoURL || (party === null || party === void 0 ? void 0 : party.defaultUserImage), firstName: m.firstName, lastName: m.lastName, size: "small" }, void 0), _jsxs("p", __assign({ className: "user-name" }, { children: [formattedUserName(m), m.yearGraduated && (_jsxs(_Fragment, { children: [_jsx("span", {}, void 0), "'", formattedUserYear(m.yearGraduated)] }, void 0)), m.linkedin && (_jsxs("a", __assign({ className: "linkedin-link", href: m.linkedin, target: "_blank", rel: "noreferrer noopener" }, { children: ["View LinkedIn ", _jsx("img", { alt: "External Link", src: IconExternalLink }, void 0)] }), void 0))] }), void 0)] }), m.id)); }) }), void 0));
};
export default Members;
